import env from 'environments';

import { openChatWidget } from 'configuration/chatWidget';
import { HeadphonesRound } from 'modules/v2/common/components/SvgIcon';
import { Button, ClosableModal } from 'modules/v2/common/AtomicDesign/atoms';

interface HelpModalProps {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
}

const HelpModal = ({ showModal, setShowModal }: HelpModalProps) => {
  const handleChat = () => {
    openChatWidget();
    setShowModal(false);
  };

  return (
    <ClosableModal
      title="Need help with something?"
      showModal={showModal}
      setShowModal={setShowModal}
      overlayClass={false}
    >
      <div className="w-[400px] max-sm:w-fit h-full">
        <div className="mb-32 font-medium">
          <div className="mb-6">
            <div className="font-bold mb-0.5 text-base">Email Us</div>
            <div className="text-neutral-500 text-sm">
              Our Member Support team is ready to help you. Just send an email to{' '}
              <a href={`mailto:${env.SUPPORT_EMAIL}`} className="text-blue-500 text-sm font-semibold underline">
                {env.SUPPORT_EMAIL}
              </a>.
            </div>
          </div>
          <div className="mb-6">
            <div className="font-bold mb-0.5 text-base">Need urgent assistance?</div>
            <div className="text-neutral-500 text-sm">
              <p>
                You can get LIVE assistance from Member Support from{' '}
                <span className="font-semibold text-neutral-700">
                  Monday-Friday, {env.SUPPORT_OPPENING_HOURS}
                </span>.
              </p>
            </div>
            <Button type="dark" className="mt-6" size="sm" buttonType="button" onClick={handleChat}>
              <div className="flex items-center gap-2">
                <HeadphonesRound fill="#ffffff" />
                <span>Chat with LIVE assistance</span>
              </div>
            </Button>
          </div>
        </div>
      </div>
    </ClosableModal>
  );
};

export default HelpModal;
